import {TemperatureUnit} from '@/common/constants/units';

export function temperatureReduce(celsiusValue: number, unit: TemperatureUnit) {
	switch (unit) {
		case TemperatureUnit.celsius:
			return celsiusValue;

		case TemperatureUnit.fahrenheit:
			return Math.round((celsiusValue * 9) / 5 + 32);
	}
}
